import axios from '@/axios'
const BASE_URL = '/api/community/public'
const api = {
  list: `${BASE_URL}/cms/userarticle/list`,
  info: `${BASE_URL}/cms/userarticle/detail`,
  add: `${BASE_URL}/cms/userarticle/add`,
  del: `${BASE_URL}/cms/userarticle/del`,
  edit: `${BASE_URL}/cms/userarticle/edit`,
  addradt: `${BASE_URL}/cms/userarticle/adddraft`,
  editraft: `${BASE_URL}/cms/userarticle/editdraft`,
  share_info: `${BASE_URL}/cms/userarticle/shareinfo`,
  add_share: `${BASE_URL}/cms/userarticle/shareid`,
  ossimg: '/api/oss/upload/url2oss',
  remove: `${BASE_URL}/cms/userarticle/recycle`,
  video_token: `${BASE_URL}/qiniu/getVideoToken`,
  editstatus: `${BASE_URL}/cms/userarticle/editstatus`,
  editsecret: `${BASE_URL}/cms/userarticle/editsecret`,
  setting: `${BASE_URL}/cms/userarticle/editsth`,
  video_log: `${BASE_URL}/qiniu/setvideokey`,
  model_info: `${BASE_URL}/fc/Rv/detail`
}

export const ArticleService = {
  getList(data) {
    return axios.get(api.list, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getInfo(data) {
    return axios.get(api.info, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getShareInfo(data) {
    return axios.get(api.share_info, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  addShare(data) {
    return axios.post(api.add_share, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  add(data) {
    return axios.post(api.add, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  del(data) {
    return axios.post(api.del, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  remove(data) {
    return axios.post(api.remove, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  edit(data) {
    return axios.post(api.edit, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  addRaft(type) {
    const datas = {
      status: 3,
      ...type
    }
    return axios.post(api.addradt, datas).then(res => {
      return Promise.resolve(res.data)
    })
  },
  saveVideoLog(data) {
    return axios.post(api.video_log, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  editRaft(data) {
    return axios.post(api.editraft, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  editStatus(data) {
    return axios.post(api.editstatus, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  editSecret(data) {
    return axios.post(api.editsecret, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  ossImg(data) {
    return axios.post(api.ossimg, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getVideoToken (data) {
    return axios.post(api.video_token, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  setting (data) {
    return axios.post(api.setting, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getModelInfo(data) {
    return axios.get(api.model_info, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  }
}
export default ArticleService